export class BambooSyncConfig {

    public apiKey: string = "";
    public subDomain: string = "";
    public hasConnectedWithMaestroWebServer: boolean = false;

}
